// extracted by mini-css-extract-plugin
export var button = "styles-module--button--c0706";
export var buttonSection = "styles-module--buttonSection--20435";
export var buttonSectionDescription = "styles-module--buttonSectionDescription--bd737";
export var buttonSectionIcon = "styles-module--buttonSectionIcon--74df1";
export var buttonsBlock = "styles-module--buttonsBlock--ef2de";
export var container = "styles-module--container--85626";
export var contentBlock = "styles-module--contentBlock--05464";
export var current = "styles-module--current--c3550";
export var discordIcon = "styles-module--discordIcon--6a7e6";
export var githubIcon = "styles-module--githubIcon--4664c";
export var header = "styles-module--header--ec99f";
export var headingLink = "styles-module--headingLink--c3ac8";
export var tutorials = "styles-module--tutorials--0d02c";